










































































































import {
  computed,
  defineComponent, reactive, Ref, ref,
} from '@vue/composition-api';
import { useFormat } from '@ideavivat/vivat-2';

import {
  getSubJob, updateSubJob, deleteProcessLog, updateSubJobProcessStatus,
} from '@/api';
import useSubJob from '@/use/useSubJob';

import CommonTagsMultiSelector from '@/components/CommonTagsMultiSelector.vue';
import CommonTimePicker from '@/components/CommonTimePicker.vue';

const CommonModalWithSubJobStationUpdate = defineComponent({
  components: {
    CommonTagsMultiSelector,
    CommonTimePicker,
  },
  setup(props, { emit }) {
    const { processStatusClassMap, getProcessStatusColor, list: processStatusList } = useSubJob();
    const toDateTime = (date: string): string => useFormat.date(date).displayShortThaiDateTime();
    const NOW = new Date();
    const modal = ref(null);
    const edit = ref(false);
    const subJob: { id: number; processLogs: any[]; } = reactive({
      id: -1,
      processLogs: [],
    });
    async function refetchQuery() {
      await getSubJobData(subJob.id);
      emit('pendingRefetchQuery');
    }
    const form = reactive({
      id: -1,
      status: '',
      start: NOW,
      timeStart: NOW.toTimeString().substr(0, 8),
      end: NOW,
      timeEnd: NOW.toTimeString().substr(0, 8),
      operatorsArray: [],
      call: async () => {
        (form.state as any).value = 'PENDING';
        if (edit.value) {
          await updateSubJobProcessStatus(form.id, {
            operators: computedOperatorsDisplay.value,
            start: `${useFormat.date(form.start).computerShortDate()} ${form.timeStart}`,
            end: `${useFormat.date(form.end).computerShortDate()} ${form.timeEnd}`,
          });
          edit.value = false;
        } else {
          await updateSubJob(subJob.id, {
            processStatus: form.status,
            start: `${useFormat.date(form.start).computerShortDate()} ${form.timeStart}`,
            end: `${useFormat.date(form.end).computerShortDate()} ${form.timeEnd}`,
            operators: computedOperatorsDisplay.value,
          });
        }
        refetchQuery();
        resetForm();
        (form.state as any).value = 'READY';
      },
      state: {
        value: 'READY',
      },
    });

    function resetForm() {
      edit.value = false;
      form.id = -1;
      form.start = NOW;
      form.status = '';
      form.timeStart = NOW.toTimeString().substr(0, 8);
      form.end = NOW;
      form.timeEnd = NOW.toTimeString().substr(0, 8);
      form.operatorsArray = [];
    }
    function pendingEdit(log: any) {
      edit.value = true;
      form.id = log.id;
      form.status = log.process;
      form.start = useFormat.date(log.start).computerShortDate();
      form.timeStart = useFormat.date(log.start).dayjs.format('HH:mm');
      form.end = useFormat.date(log.end).computerShortDate();
      form.timeEnd = useFormat.date(log.end).dayjs.format('HH:mm');
      form.operatorsArray = log.operators.replaceAll('-', '').split(',').filter((op: string) => op !== '');
    }
    async function compose(id: number) {
      subJob.id = id;
      await getSubJobData(id);
      (modal.value as any).open();
    }
    function close() {
      (modal.value as any).close();
    }

    async function getSubJobData(id: number) {
      const result = (await getSubJob(id)).data;
      subJob.processLogs = result.process_logs.reverse() || [];
    }

    const operatorList: Ref<string[]> = ref(JSON.parse(localStorage.getItem('operatorsList') || '[]'));
    const computedOperatorList = computed(() => operatorList.value);
    function clearOperatorsList() {
      localStorage.removeItem('operatorsList');
      operatorList.value = [];
    }

    function addOperatorByText(text: string) {
      const index = operatorList.value.indexOf(text);
      if (index === -1) {
        operatorList.value.push(text);
        localStorage.setItem('operatorsList', JSON.stringify(operatorList.value));
      }
    }

    const computedOperatorsDisplay = computed(() => form.operatorsArray.join(',') || '-');

    async function deleteProcessLogAction(id: number) {
      (form.state as any).value = 'PENDING';
      await deleteProcessLog(id);
      await getSubJobData(subJob.id);
      emit('pendingRefetchQuery');
      (form.state as any).value = 'READY';
    }

    async function updateActiveProcessStatus(id: number) {
      await updateSubJobProcessStatus(id, { active: true });
      refetchQuery();
    }

    return {
      toDateTime,
      getProcessStatusColor,
      processStatusClassMap,
      processStatusList,

      computedOperatorsDisplay,

      modal,
      compose,
      close,

      form,
      edit,
      subJob,
      resetForm,
      pendingEdit,

      clearOperatorsList,
      operatorList,
      computedOperatorList,
      addOperatorByText,

      updateActiveProcessStatus,
      deleteProcessLogAction,
    };
  },
});

export default CommonModalWithSubJobStationUpdate;
